import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftActionsButtons,
  CftTank,
  CftLeavingModal,
  CftExportData,
} from "../../components";
import routes from "../../utils/cftRoutes";
import useCftCattleValues from "../../utils/useCftCattleValues";

import "../styles/progressDashboard.scss";
import { CattleHerdFeedForm } from "../../forms/cattle";

export default function PigsHerdFeedPage() {
  const { t } = useTranslation(["cftTurkey", "cftChickenBroiler", "cftCattle"]);
  const history = useHistory();
  const { store } = useCftCattleValues();
  const [showLeavingModal, setShowLeavingModal] = useState(false);
  const stopOverflow = () => {
    document.querySelector("body").style.overflowY = "hidden";
    document.querySelector("html").style.overflow = "hidden";
  };

  return (
    <CftLayout
      style={{ marginTop: 0 }}
      header={
        <CftHeader
          cropName={t("cftCattle:tag", "Bydło opasowe")}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportData type="pigs" />
              <CftActionsButtons.CancelButton
                hasText={false}
                onClick={() => {
                  stopOverflow();
                  setShowLeavingModal(!showLeavingModal);
                }}
              />
            </CftTank>
          }
        />
      }
    >
      <CftSection withNoSpace style={{ paddingTop: "7rem" }}>
        <CattleHerdFeedForm />
      </CftSection>
      <CftLeavingModal
        isVisible={showLeavingModal}
        hide={() => setShowLeavingModal(!showLeavingModal)}
        type="bothCalc"
        goToProfile={() => history.push(routes.MAIN)}
        dataReport={JSON.stringify(store)}
      />
    </CftLayout>
  );
}
